import Keyboard from 'simple-keyboard';
import inputMask from 'simple-keyboard-input-mask';
import 'simple-keyboard/build/css/index.css';

export default {
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
  data: () => ({
    keyboard: null,
    timeout: null,
  }),
  methods: {
    createKeyboard(data) {
      if (!('type' in data)) data.type = 'numeric';
      if (!('regex' in data)) data.regex = /^[0-9]+$/;
      if (!('class' in data)) data.class = 'simple-keyboard';

      let layout;

      if (data.type === 'numeric') {
        layout = {
          default: [
            '1 2 3',
            '4 5 6',
            '7 8 9',
            '{clean} 0 {bksp}'
          ]
        };
      }
      else {
        layout = {
          caps: [
            '1 2 3 4 5 6 7 8 9 0 - {bksp}',
            'Q W E R T Y U I O P /',
            '{caps} A S D F G H J K L _',
            '{clean} Z X C V B N M .',
            '.COM {space} @'
          ],
          default: [
            '1 2 3 4 5 6 7 8 9 0 - {bksp}',
            'q w e r t y u i o p /',
            '{caps} a s d f g h j k l _',
            '{clean} z x c v b n m .',
            '.com {space} @'
          ]
        };
      }

      const updateButtons = () => {
        document.querySelectorAll('.hg-functionBtn')
          .forEach(element => element.setAttribute('class', 'hg-button hg-standardBtn'));

        document.querySelector('div[data-skbtn="{bksp}"]').innerHTML = '<img src="/assets/backspace.svg" />';
      };

      if (this.keyboard) this.destroyKeyboard(0);

      const params = {
        display: {
          '{caps}': 'Caps',
          '{clean}': this.$vuetify.lang.t('$vuetify.btn.clear'),
          '{space}': this.$vuetify.lang.t('$vuetify.btn.space'),
        },
        layout,
        modules: [inputMask],
        onChange: value => {
          if ('form' in data && 'field' in data) {
            this.$set(data.form, data.field, value);
          }

          updateButtons();
        },
        onKeyReleased: button => {
          updateButtons();

          switch(button) {
            case '{clean}':
              this.$set(data.form, data.field, '');
              this.keyboard.setInput('');
              break;
            case '{caps}': {
                const layoutName = this.keyboard.options.layoutName === 'default' ? 'caps' : 'default';
                this.keyboard.setOptions({ layoutName });
                updateButtons();
              };
              break;
          };
        }
      };

      if (data.mask) {
        params.inputMask = {
          default: {
            mask: data.mask,
            regex: data.regex
          }
        };
      }
      
      this.keyboard = new Keyboard(`.${data.class}`, params);

      if ('form' in data && 'field' in data) {
        this.keyboard.setInput(data.form[data.field]);
      }

      updateButtons();
    },
    destroyKeyboard(time = 200) {
      if (!this.keyboard) return true;

      return new Promise((accept) => {
        this.timeout = setTimeout(() => {
          this.keyboard.destroy();
          this.keyboard = null;
          accept(true);
        }, time);
      });
    }
  },
};